<template>
  <nav aria-label="Breadcrumb" class="footer-breadcrumb">
    <ul class="breadcrumb-list">
      <li>
        <a class="d-flex" :href="home" :aria-current="breadcrumbs.length === 0 ? 'Home' : null">
          <BrandLogo :force="'mobile'" class="m-r-3" />
          <div>{{ insertString("Global", "Home") }}</div>
        </a>
      </li>
      <li v-for="(breadcrumb, index) in breadcrumbs" :key="index">
        <a :aria-current="index === breadcrumbs.length - 1 ? breadcrumb.DisplayName : null" :href="breadcrumb.ContentLink" :title="breadcrumb.DisplayName">
        {{ breadcrumb.DisplayName }}</a>
      </li>
    </ul>
      </nav>
</template>
<script>
import Api from '@/Scripts/api/api';
import BrandLogo from '@/Scripts/components/layout/logo/BrandLogo.vue';

export default {
  components: {
    BrandLogo
  },
  computed: {
    home () {
      return `/${document.getElementsByTagName('html')[0].getAttribute('lang')}`;
    }
  },
  methods: {
    getBreadcrumb () {
      Api.get(`/api/layout/breadcrumb/?contentReferenceString=${document.body.getAttribute('data-content-reference')}`).then(response => {
        this.breadcrumbs = response.data.Breadcrumbs;
      });
    }

  },
  data: function () {
    return {
      breadcrumbs: []
    };
  },
  created () {
    this.getBreadcrumb();
  }
};
</script>
<style lang="scss">
@import "@/scss/defaults.scss";
.footer-breadcrumb {
  display: block;
  font-weight: normal;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  @include media-breakpoint-down(sm) {
    display: none;
  }
  .breadcrumb-list {
    display: flex;
    flex-direction: row;
    list-style: none;
    li {
      display: inline;
      padding-left: 5px;

      &::before {
        display: inline-block;
        width: 7px;
        min-width: 7px;
        height: 7px;
        margin-right: 0;
        content: none;
      }

      &:not(:first-child) {
        &::before {
          display: inline-block;
          width: 7px;
          min-width: 7px;
          height: 7px;
          margin-right: 0;
          content: "/";
        }
      }

      :first-child {
      padding-left: 0;
    }

    &:last-child {
      color: $white;

      &::before {
        border-color: $white;
      }
    }
    }
  }

  svg {
    width: 16px;
    height: 21px;
  }
  span {
    display: inline;
    padding-left: 5px;

    &::before {
      display: inline-block;
      width: 7px;
      min-width: 7px;
      height: 7px;
      margin-right: 0;
      // border: 1px solid #bdbdbd;
      // border-left: 0;
      // border-bottom: 0;
      // transform: rotate(45deg);
      content: "/";
    }

    &:first-child {
      padding-left: 0;

      &::before {
        content: none;
      }
    }

    &:last-child {
      color: $white;
      content: "";

      &::before {
        border-color: $white;
      }
    }
  }
}
</style>
